module.exports = __webpack_public_path__ + "static/responsive-d85dcf4c52498cfdf933e982cd5c35fc.svg";